module.exports = __webpack_public_path__ + "img/zdfsde.e1fa91bd.png";